export const isArray = Array.isArray || ((x) => x && typeof x.length === 'number');
